module.exports = __webpack_public_path__ + "media/scholarship_winners/winner-tips_300x115-f4f9e241.png";